export class Role {
	id: number;
    name: string;
    description: string;
    status: number;
    updated_at: any;
    permissions: Array<string>;
}
